/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { PlatformHelper } from "../helpers/platformHelper";

import { AppConfigDefault } from "./AppConfig.default";
import { AppConfigTizen } from "./AppConfig.tizen";
import { AppConfigWebOS } from "./AppConfig.webos";

let AppConfig: any;

switch (PlatformHelper.Platform) {
  case "TIZEN":
    AppConfig = AppConfigTizen;
    break;
  case "WEB_OS":
    AppConfig = AppConfigWebOS;
    break;
  default:
    AppConfig = AppConfigDefault;
    break;
}

export { AppConfig };
